import secondaryButtonColorBorderTextRule from '../../../../../common/algorithms/secondary-button-color-border-text-rule';

const secondary = (params) => secondaryButtonColorBorderTextRule(params);

export default secondary;
